import axios from 'axios';
import { config } from '../../config/Config';

/**
 * The caller's AI usage on the game in scope (X-Web-Game-Id, set by the axios interceptor), as the usage gate checks
 * it: { credits, limits }. `credits` is { canSpend, reason, exempt, mode, totalMicroUsd, usedMicroUsd,
 * remainingMicroUsd }, or null when the server could not read it; `limits` is the org's spending windows
 * [{ window: 'HOUR' | 'DAY', usedPercent, resetsAt }], empty when there are none to show.
 */
export const getChatCredits = async () => {
    const response = await axios.get(`${config.serverBaseUrl}/v1/web/chat/credits`);
    return { credits: response.data?.credits ?? null, limits: response.data?.limits ?? [] };
};
